<template>

  <div class="join-stage-page">
    <Header></Header>
    <section class="join-stage">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h1>Join Stage</h1>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="join-stage-filter-container">
              <h2>{{totalStageFound}} Stages found</h2>
              <a data-toggle="collapse" href="#SelectRole" role="button" aria-expanded="false" aria-controls="SelectRole">
                Select Role
              </a>
              <div class="collapse" id="SelectRole">
                <div class="card card-body">
                  <ul>
                    <li v-for="(list) in roles" v-bind:key="list.id" v-if="list">
                      <div class="field-checkbox">
                        <input type="checkbox" :value="list" :id="`checkbox_`+list" />
                        <label :class="checkboxActive" v-on:click="checkboxRoleFuntion" :for="`checkbox_`+list">{{list}}</label>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <a data-toggle="collapse" href="#SelectLocation" role="button" aria-expanded="false" aria-controls="SelectLocation">
                Select Location
              </a>
              <div class="collapse" id="SelectLocation">
                <div class="card card-body">
                  <ul>
                    <li v-for="(list) in locations" v-bind:key="list.id" v-if="list">
                      <div class="field-checkbox">
                        <input type="checkbox" :value="list" :id="`checkbox_`+list" />
                        <label :class="checkboxActive" v-on:click="checkboxLocationFuntion" :for="`checkbox_`+list">{{list}}</label>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <a data-toggle="collapse" href="#FilterbyDate" role="button" aria-expanded="false" aria-controls="FilterbyDate">
                Filter by Date
              </a>
              <div class="collapse" id="FilterbyDate">
                <div class="card card-body">
                  <div class="input-field">
                    <datepicker placeholder="Event Date" v-model="date" @selected="eventDateFuntion" id="event-date" format="MMMM d yyyy" required></datepicker>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-8 join-stage-container">
            <div class="row join-stage-row" v-if="lists.length && list" v-for="(list) in lists" v-bind:key="list.id">
              <div class="col-md-10">
                <div class="stage-img background-fit" :style="{ backgroundImage: `url(${imageUrl + list.videoId[0].videoImageFile})` }"></div>
                <div class="stage-content">
                  <h2>{{list.title}}</h2>
                  <h3>{{list.eventLocation}}</h3>
                  <div class="roles-list 11" v-if="!role && list.role && list.role.length">
                    <span v-for="(role) in list.role" v-bind:key="role.id">{{role.role}}<i>, </i> </span>
                  </div>
                  <div class="roles-list 22" v-if="!list.role && list.roleId && list.roleId.length">
                    <span v-for="(r) in list.roleId" v-bind:key="r.id">{{r.role}}<i>, </i> </span>
                  </div>
                  <h4>{{list.date | formatDate}}</h4>
                </div>
              </div>
              <div class="col-md-2 join-stage-col-2">
                <router-link :to="`/stage/`+list._id">View Stage</router-link>
              </div>
            </div>
            <div class="row" v-if="!lists.length">
              <div class="col-md-12">
                <h3 class="noFound">No stages with this filter</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from './Header'
import Footer from './Footer'
import $ from "jquery"
import Loader from './include/Loader'
import axios from 'axios'
import backgroundUrl from '@/assets/img/image6.jpg'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'
export default {
  name: 'JoinStage',
  components: {
    'Header': Header,
    'Footer': Footer,
    'Loader': Loader,
    'Datepicker': Datepicker
  },
  mounted () {
      axios
          .get('/stages', {
              params: {
                  stage: 'upcoming'
              }
          })
          .then(response => {
              this.loading = false
              this.lists = response.data
              if(response.data.length){
                  this.totalStageFound = response.data.length
              } else {
                  this.totalStageFound = 0
              }
          })
          .catch(error => console.log(error))
      axios
          .get('/roles')
          .then(response => {
              this.loading = false
              this.roles = response.data
          })
          .catch(error => console.log(error))
      axios
          .get('/locations')
          .then(response => {
              this.loading = false
              this.locations = response.data
          })
          .catch(error => console.log(error))
  },
    methods: {
        checkboxRoleFuntion: function (event) {
            $(event.target).toggleClass('active')
            this.filterFunction()
        },
        checkboxLocationFuntion: function (event) {
            $(event.target).toggleClass('active')
            this.filterFunction()
        },
        eventDateFuntion: function (event) {
            let $this = this
            setTimeout(function () {
                $this.date = moment(String($this.date)).format('YYYY-MM-DD')
                // $this.nextdate = moment(String($this.date)).format('YYYY-MM-DD')
                $this.filterFunction()
            }, 100)
        },
        filterFunction: function () {
            let roleArray = []
            $('#SelectRole ul li').each(function (key, value) {
                if($(this).find('label').hasClass('active')){
                    roleArray.push($(this).find('input').val())
                }
            })
            let locationArray = []
            $('#SelectLocation ul li').each(function (key, value) {
                if($(this).find('label').hasClass('active')){
                    locationArray.push($(this).find('input').val())
                }
            })
            axios
                .get('/stageFilter', {
                    params: {
                        role: roleArray,
                        eventLocation: locationArray,
                        eventDate: this.date
                    }
                })
                .then(response => {

                    let stages = []
                    let stageIds = []
                    $.each(response.data, function(key, value) {
                        if(!stageIds.includes(value.stageId._id)){
                            stages.push(value.stageId)
                            stageIds.push(value.stageId._id)
                        }
                    })
                    this.lists = stages
                    if(stages.length){
                        this.totalStageFound = stages.length
                    } else {
                        this.totalStageFound = 0
                    }

                })
                .catch(error => console.log(error))
        }
    },
  data () {
    return {
        backgroundUrl: backgroundUrl,
        checkboxActive: '',
        imageUrl: process.env.imageUrl,
        loading: true,
        msg: 'Welcome to Your Vue.js App',
        lists: '',
        roles: '',
        locations: '',
        totalStageFound: '',
        date: '',
        role: '',
        roleId: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/JoinStage.vue